import * as actionTypes from "../actionTypes";

const initialState = {
  promptType: null,
  certainty: null,
  careerAspirations: "",
  lastProfileUpdateAt: null,
  isLoading: false,
  fetchAttempted: false,
  dismissed: false,
  shownLogged: false,
  isSaving: false,
  saveError: "",
};

const promptReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.FETCH_PROMPT_STATUS:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_PROMPT_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        fetchAttempted: true,
        promptType: payload.prompt_type,
        certainty: payload.certainty,
        careerAspirations: payload.career_aspirations || "",
        lastProfileUpdateAt: payload.last_profile_update_at || null,
        dismissed: false,
        shownLogged: false,
        saveError: "",
      };
    case actionTypes.FETCH_PROMPT_STATUS_ERROR:
      return {
        ...state,
        isLoading: false,
        fetchAttempted: true,
        promptType: null,
      };
    case actionTypes.DISMISS_PROMPT:
      return {
        ...state,
        dismissed: true,
      };
    case actionTypes.MARK_PROMPT_SHOWN_LOGGED:
      return {
        ...state,
        shownLogged: true,
      };
    case actionTypes.SET_PROMPT_SAVING:
      return {
        ...state,
        isSaving: payload,
        saveError: payload ? "" : state.saveError,
      };
    case actionTypes.SET_PROMPT_SAVE_ERROR:
      return {
        ...state,
        isSaving: false,
        saveError: payload,
      };
    case actionTypes.CLEAR_PROMPT_SAVE_ERROR:
      return {
        ...state,
        saveError: "",
      };
    case actionTypes.SIGN_OUT:
      return initialState;
    default:
      return state;
  }
};

export default promptReducer;
